export const TEMP_TUTORIAL_FORMATS = [
  {
    id: "both shoes",
    prescan: [
      {
        id: 0,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/screen-lock.webp`,
        text: "If using iPhone, lock the device screen.",
        checkLabel: "Screen locked to portrait",
      },
      {
        id: 1,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/both-shoes/1.webp`,
        text: "Take off your shoes and roll up your pants.",
        checkLabel: "Shoes off, pants rolled up",
      },
      {
        id: 2,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/both-shoes/2.webp`,
        text: "Position your feet and credit card as shown below.",
        checkLabel: "Feet & credit card positioned",
      },
      {
        id: 3,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/both-shoes/3.webp`,
        text: "Before scan, be sure to align and tilt your device to a proper position.",
        checkLabel: "Device positioned",
      },
    ],
    scan: [
      {
        id: 0,
        type: "vid",
        url: "https://asset.snugfitsolutions.com/tutorial/two-feet-scan.mp4",
        text: "Be sure to follow this scanning procedure.",
        checkLabel: "Understood",
      },
    ],
  },
  {
    id: "shoe",
    prescan: [
      {
        id: 0,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/screen-lock.webp`,
        text: "If using iPhone, lock the device screen.",
        checkLabel: "Screen locked to portrait",
      },
      {
        id: 1,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/shoe/1.webp`,
        text: "Take off your shoes and roll up your pants.",
        checkLabel: "Shoes off, pants rolled up",
      },
      {
        id: 2,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/shoe/2.webp`,
        text: "Position your feet and credit card as shown below.",
        checkLabel: "Feet & credit card positioned",
      },
      {
        id: 3,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/shoe/3.webp`,
        text: "Before scan, be sure to align and tilt your device to a proper position.",
        checkLabel: "Device positioned",
      },
    ],
    scan: [
      {
        id: 0,
        type: "vid",
        url: "https://asset.snugfitsolutions.com/tutorial/one-foot-scan.mp4",
        text: "Be sure to follow this scanning procedure.",
        checkLabel: "Understood",
      },
    ],
  },
  {
    id: "fo",
    prescan: [
      {
        id: 0,
        type: "img",
        url: `${process.env.PUBLIC_URL}/tutorials/screen-lock.webp`,
        text: "If using iPhone, lock the device screen.",
        checkLabel: "Screen locked to portrait",
      },
    ],
    scan: [
      {
        id: 0,
        type: "vid",
        url: "https://asset.snugfitsolutions.com/tutorial/fo-scan.mp4",
        text: "Be sure to follow this scanning procedure.",
        checkLabel: "Understood",
      },
    ],
  },
];
